/* eslint global-require: "off" */
import Vue from 'vue';
import Router from 'vue-router';

import restResourceRoutes from '@/router/rest-resource-routes';
import scrollBehavior from '@/router/scroll-behavior';
import AbstractRoute from '@/router/AbstractRoute.vue';

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: {
        title: 'pages.login.meta.title',
        breadcrumb: 'pages.login.meta.breadcrumb',
      },
      component: () => import('@/pages/Login.vue'),
    },
    {
      path: '/',
      name: 'home',
      redirect: '/dashboard',
      meta: {
        title: 'pages.home.meta.title',
        breadcrumb: 'pages.home.meta.breadcrumb',
        auth: true,
      },
      component: require('@/layouts/AdminLayout.vue').default,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          meta: {
            title: 'pages.dashboard.meta.title',
            breadcrumb: 'pages.dashboard.meta.breadcrumb',
            tab: 'pages.dashboard.meta.tab',
          },
          component: () => import('@/pages/Dashboard.vue'), // eslint-disable-line
        },
        {
          path: 'admin',
          props: { store: { namespace: 'Pages/Admin' } },
          meta: {
            title: 'pages.admin.meta.title',
            breadcrumb: 'pages.admin.meta.breadcrumb',
          },
          component: AbstractRoute,
          children: [
            restResourceRoutes(require('@/pages/admin/users.config').default),
          ],
        },
        {
          path: 'site',
          props: { store: { namespace: 'Pages/Site' } },
          meta: {
            title: 'pages.site.meta.title',
            breadcrumb: 'pages.site.meta.breadcrumb',
          },
          component: AbstractRoute,
          children: [
            restResourceRoutes(require('@/pages/site/users.config').default),
          ],
        },
        {
          path: 'formaat',
          props: { store: { namespace: 'Pages/Formaat' } },
          meta: {
            title: 'pages.formaat.meta.title',
            breadcrumb: 'pages.formaat.meta.breadcrumb',
          },
          component: AbstractRoute,
          children: [
            restResourceRoutes(require('@/pages/formaat/client.config').default),
          ],
        },
      ],
    },
  ],
});

export default router;
